<template>
  <b-modal v-model="modalShow" hide-backdrop hide-header hide-footer no-fade id="artwork-modal">
    <div class="d-landscape-none" style="margin-left: -15px; margin-right: -15px;">
      <RollImageLg :directoryNo="'' + directoryNo" :rotationLv="rotationLv" @loaded="sliderShow = true"/>
    </div>
    <div class="container container-uedahiraku h-100 d-lg-flex flex-column justify-content-center">
      <div class="row">
        <div class="d-portrait-none col-md-12 col-lg-8">
          <RollImageLg :directoryNo="'' + directoryNo" :rotationLv="rotationLv" @loaded="sliderShow = true" />
        </div>
        <div class="d-none d-lg-flex col-lg-4 pt-5">
          <div class="pt-4">
            <h2 class="font-weight-bold">{{ artworkOptions[directoryNo-1].title }}</h2>
            <h4 class="futura tracking-1 text-uppercase">{{ artworkOptions[directoryNo-1].titleEn }}</h4>
            <h6 class="font-weight-bold mt-5">{{ artworkOptions[directoryNo-1].description }}</h6>
            <p class="futura h5">{{ artworkOptions[directoryNo-1].price }}-</p>
            <a v-if="artworkOptions[directoryNo-1].shop" :href="artworkOptions[directoryNo-1].shop" target="_blank" class="btn btn-outline-dark font-weight-bold border-2px mt-5">
              ショップページはこちら
            </a>
          </div>
          <!-- <div class="row d-none d-md-flex mt-5">
            <div class="col-6">
              <img class="img-fluid" src="@/assets/images/works/img-loading.svg">
            </div>
            <div class="col-6">
              <img class="img-fluid" src="@/assets/images/works/img-loading.svg">
            </div>
          </div> -->
        </div>
      </div>
      <div v-if="isMobile().any" class="row justify-content-center mt-md-5">
        <div class="col-md-6 col-lg-5 col-xl-4">
          <div class="touch-slider"  :class="sliderShow? 'show': ''">
            <b-form-input v-model="rotationLv" :class="isMobile().any? 'mobile': ''" type="range" min="1" max="8"></b-form-input>
          </div>
        </div>
      </div>
      <!-- <div class="row d-none d-sm-flex d-lg-none">
        <div class="col-6">
          <img class="img-fluid" src="@/assets/images/works/img-loading.svg">
        </div>
        <div class="col-6">
          <img class="img-fluid" src="@/assets/images/works/img-loading.svg">
        </div>
      </div> -->

      <div class="row mt-4 d-lg-none">

        <div class="col-12 col-md-6 offset-md-1">
          <h2 class="font-weight-bold">{{ artworkOptions[directoryNo-1].title }}</h2>
          <h4 class="futura tracking-1">{{ artworkOptions[directoryNo-1].titleEn }}</h4>
        </div>
        <div class="col-12 col-md-5">
          <h6 class="font-weight-bold">{{ artworkOptions[directoryNo-1].description }}</h6>
          <p class="futura h5">{{ artworkOptions[directoryNo-1].price }}-</p>
          <a v-if="artworkOptions[directoryNo-1].shop" :href="artworkOptions[directoryNo-1].shop" target="_blank" class="btn btn-outline-dark font-weight-bold border-2px mt-md-4">
            ショップページはこちら
          </a>
        </div>

      </div>
    </div>
    <b-button variant="outline-dark" class="btn-close-modal py-0 pl-3 pr-2" @click="modalShow = false">
      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
        <line x1="0" y1="0" x2="10" y2="10" stroke="currentColor" />
        <line x1="0" y1="10" x2="10" y2="0" stroke="currentColor" />
      </svg>
      <div class="futura back">BACK</div>
    </b-button>
    <h2 class="right-title d-none d-md-block futura tracking-1">ART WORK</h2>
    <div class="right-item d-none d-md-block">
      <div class="tategaki font-weight-bold">
        紙とセロハンテープでつくられる生き物たち
      </div>
    </div>
    <img class="roll-icon d-none d-md-inline-block" src="@/assets/images/works/rotation.svg">
    <GlobalNavPc @buttonDidClick="modalShow = false"/>
  </b-modal>
</template>

<script>
import isMobile from 'ismobilejs'
import RollImageLg from '@/components/RollImageLg'
import GlobalNavPc from '@/components/GlobalNavPc'

export default {
  components: {
    RollImageLg, GlobalNavPc
  },
  data() {
    return {
      isMobile,
      modalShow: false,
      sliderShow: false,
      rotationLv: '1',
      directoryNo: 1,
      artworkOptions: [
        {no: 1, title: 'ティラノサウルス', titleEn: 'Tyrannosaurus', description: '最大級の肉食恐竜', price: '70,000', shop: 'https://uedahiraku.thebase.in/items/34449801'},
        {no: 2, title: 'イリエワニ', titleEn: 'Saltwater crocodile', description: '現存する爬虫類で最大。大体4mから6mに', price: '40,000', shop: 'https://uedahiraku.thebase.in/items/34449834'},
        {no: 3, title: 'ステゴサウルス', titleEn: 'Stegosaurus', description: '背中に生えたとがった板が特徴。一番好きな恐竜', price: '45,000', shop: 'https://uedahiraku.thebase.in/items/34450076'},
        {no: 4, title: 'ゴルゴサウルス', titleEn: 'Gorgosaurus', description: 'ティラノサウルス科の恐竜でスピード特化型', price: '22,000', shop: 'https://uedahiraku.thebase.in/items/34842101'},
        {no: 5, title: 'エゾヒグマ', titleEn: 'Ezo brown bear', description: '日本で最大の陸上動物', price: '15,000', shop: 'https://uedahiraku.thebase.in/items/34842179'},
        {no: 6, title: 'コモドオオトカゲ', titleEn: 'Komodo dragon', description: 'トカゲの中で最大', price: '14,000', shop: 'https://uedahiraku.thebase.in/items/34842243'},
        {no: 7, title: 'ヌマワニ', titleEn: 'Marsh crocodile', description: 'あまり大きな獲物は襲わない', price: '14,000', shop: 'https://uedahiraku.thebase.in/items/34842331'},
        {no: 8, title: 'プロングホーン', titleEn: 'Pronghorn', description: '地上で2番目に早い。1番はチーターである', price: '14,000', shop: 'https://uedahiraku.thebase.in/items/34842465'},
        {no: 9, title: 'ヨークシャー', titleEn: 'Middle White', description: '食用の豚', price: '9,000', shop: 'https://uedahiraku.thebase.in/items/34842655'},
        {no: 10, title: 'ツキノワグマ', titleEn: 'Asiatic black bear', description: '胸に三日月模様がある', price: '13,000', shop: 'https://uedahiraku.thebase.in/items/34842737'},
        {no: 11, title: 'コシグロペリカン', titleEn: 'Australian pelican', description: '腰から背中にかけて黒い模様がある', price: '14,000', shop: 'https://uedahiraku.thebase.in/items/34842788'},
        {no: 12, title: '紀州犬', titleEn: 'Kishu dog', description: '猟犬', price: '9,000', shop: 'https://uedahiraku.thebase.in/items/34842967'},
        {no: 13, title: 'キイロヒヒ', titleEn: 'Yellow baboon', description: 'にごった黄色が特徴のヒヒ', price: '10,000'},
        {no: 14, title: 'リカオン', titleEn: 'African wild dog', description: '黄色と黒のまだら模様が特徴である', price: '9,000'},
        {no: 15, title: 'オオタカ', titleEn: 'Goshawk', description: '蒼鷹とかいて、オオタカと呼ぶ', price: '10,000'},
        {no: 16, title: 'イリオモテヤマネコ', titleEn: 'Iriomote cat', description: '絶滅危惧種で、特別天然記念物', price: '9,000'},
        {no: 17, title: 'チベットモンキー', titleEn: 'Tibetan monkey', description: 'チベットに棲むサル', price: '8,000'}
      ]
    }
  },

  methods: {
    show(dirNo) {
      this.sliderShow = false
      this.directoryNo = dirNo
      this.modalShow = true
    }
  }
}
</script>

<style lang="scss">
#artwork-modal {
  .modal-dialog {
      max-width: 100%;
      margin: 0;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      height: 100%;
      display: flex;
      position: fixed;
      z-index: 100000;
      .modal-content {
        border: none;
        // background-color: rgba(255,255,255,0);
        .modal-body {
          height: 100%;
        }
      }
  }
  .touch-slider {
    opacity: 0;
    transition: opacity 0.6s;
    pointer-events: none;
    &.show {
      opacity: 1;
      pointer-events: inherit;
    }
  }

}
</style>

<style lang="scss" scoped>
.btn-close-modal {
  position: fixed;
  bottom: 13px;
  left: 13px;
  height: 35px;
  display: flex;
  align-items: center;
  @media screen and (min-width: 768px){
    bottom: 20px;
    left: inherit;
    right: 20px;    
  }
}
.d-landscape-none {
  @media (orientation: landscape) {
    display: none;
  }
}
.d-portrait-none {
  @media (orientation: portrait) {
    display: none;
  }
}
.back {
  display: inline-block;
  width: 100px;
}
.roll-icon {
  position: fixed;
  top: 450px;
  right: 36px;
  @media screen and (min-width: 1200px) {
    top: 500px;
  }
}
</style>